module.exports = __webpack_public_path__ + "static/media/confused-face-svgrepo-com.678200a5.svg";